import React from 'react'

import { CellsWithSpacer } from './CellsWithSpacer'

interface HeadRowProps extends Omit<React.HTMLAttributes<HTMLTableRowElement>, 'className'> {
  children: React.ReactNode;
}

export function HeadRow ({ children, ...props }: HeadRowProps) {
  return (
    <tr {...props} className='group/row'>
      <td className='w-36 bg-white border-gradient-to-b from-gray-300 to-gray-200 before:pt-0 before:pl-0 !sticky left-0 top-0 z-[1]' />
      <CellsWithSpacer>{children}</CellsWithSpacer>
    </tr>
  )
}

HeadRow.displayName = 'PlanTable.HeadRow'
